<script>
import DidoExplore from "./components/Explore.vue";

export default {
  name: "DidoExploreCe",
  components: {
    DidoExplore,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoFilter: { type: String, required: false, default: void 0 },
  },
  emits: [
    "click-card",
    "label-selection-on-card",
    "new-filter",
    "bad-configuration",
  ],
  template: `
    <DidoExplore
      :api-url="didoUrl"
      :explore-filter="didoFilter"
      @click-card="$emit('click-card', $event)"
      @label-selection-on-card="$emit('label-selection-on-card', $event)"
      @new-filter="$emit('new-filter', JSON.parse(JSON.stringify($event)))"
      @bad-configuration="$emit('bad-configuration')"
    />`,
};
</script>
